<template>
  <div class="forgot-password">
    <div class="forgot-password--background-layer" @click="close"></div>
    <form class="forgot-password--pane" @submit.prevent="requestResetPassword">
      <div class="forgot-password--close-button" @click="close" role="button">
        <img :src="require('@/assets/img/icons/close.svg')" alt="x">
      </div>
      <div class="forgot-password--logo">
        <img alt="Fuell logo" :src="require('@/assets/img/logo.svg')">
      </div>

      <div v-if="!this.showMailSentFlag">
        <div class="forgot-password--icon">
          <img :src="require('@/assets/img/icons/icon-reset-pass.svg')" alt="reset password">
        </div>

        <h1 class="Tit Tit--login" v-t="{ path: 'login_password_rem_greeting' }"></h1>

        <div>
          <div class="input--block">
            <label for="email" class="form--label">{{ $t('EMAIL').toUpperCase() }}</label>
            <div class="Form-field" :class="{ 'Form--field-error': $v.email.$error || error }" v-focus-input>
              <input type="text" class="Input-text" name="email" autocomplete="email" :placeholder="$t('EMAIL')"
                v-model.trim="email" v-autofocus>
            </div>
          </div>
        </div>

        <span v-if="error">
          <p class="forgot-password--error" v-t="{ path: 'login_password_rem_error' }"></p>
        </span>
        <div class="mt-2">
          <vue-recaptcha v-if="showCaptcha" :sitekey="siteKey" @verify="verifyCaptcha"></vue-recaptcha>
        </div>
        <div class="forgot-password--button">
          <button class="Button Button--primary w-100" type="submit" v-t="{ path: 'ACTION_SEND' }"
            :disabled="!canBeSubmitted"></button>
        </div>
      </div>

      <div v-else>
        <div class="forgot-password--sent-icon">
          <img :src="require('@/assets/img/icons/email-sent-icon.svg')" alt="reset password">
        </div>
        <div class="Tit Tit--login Tit--login-sent" v-t="{ path: 'login_password_rem_sent' }"></div>
      </div>

    </form>
  </div>
</template>
<script>
import { VueRecaptcha } from 'vue-recaptcha'
import { required, email } from 'vuelidate/lib/validators'
const { validationMixin } = require('vuelidate')

export default {
  name: 'LoginForgotPasswordForm',
  components: { VueRecaptcha },
  mixins: [validationMixin],
  data () {
    return {
      email: '',
      showMailSentFlag: false,
      error: false,
      showCaptcha: false,
      successCaptcha: false
    }
  },
  validations: {
    email: {
      required,
      email
    }
  },
  watch: {
    email (newVal) {
      if (newVal !== '') {
        this.error = false
      }
    }
  },
  computed: {
    siteKey () {
      return process.env.VUE_APP_CAPTCHA
    },
    canBeSubmitted () {
      return !this.$v.$invalid && ((this.successCaptcha && this.showCaptcha) || (!this.showCaptcha))
    }
  },
  mounted () {
    let opened = parseInt(localStorage.getItem('forgotPassword')) || 0
    localStorage.setItem('forgotPassword', opened + 1)
    if (opened >= 3) {
      this.showCaptcha = true
    }
  },
  methods: {
    verifyCaptcha () {
      this.successCaptcha = true
    },
    requestResetPassword () {
      this.$v.$touch()
      if (!this.$v.$invalid && ((this.successCaptcha && this.showCaptcha) || (!this.showCaptcha))) {
        this.$store.dispatch('LoginStore/requestResetPassword', { email: this.email }).then(() => {
          this.showMailSent()
        }).catch(() => {
          this.email = ''
          this.error = true
        })
      }
    },
    showMailSent () {
      this.showMailSentFlag = true
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.forgot-password {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.forgot-password--background-layer {
  background-color: rgba(0, 0, 0, 0.75);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.forgot-password--logo {
  text-align: center;
  margin-top: -5px;
}

.forgot-password--pane {
  position: relative;
  background-color: var(--white);
  max-width: 375px;
  width: 100%;
  margin: 20px;
  padding: 25px;
  border-radius: 4px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.08), 0 3px 6px 0 rgba(0, 0, 0, 0.03),
    0 5px 10px 0 rgba(0, 0, 0, 0.04), 0 10px 18px 0 rgba(0, 0, 0, 0.05),
    0 16px 30px 0 rgba(0, 0, 0, 0.06), 0 40px 80px 0 rgba(0, 0, 0, 0.07);
}

.forgot-password--icon {
  text-align: center;
  margin-top: 39px;
  margin-bottom: 13px;
}

.forgot-password--sent-icon {
  text-align: center;
  margin-top: 48px;
  margin-bottom: 14px;
}

.forgot-password--icon img {
  width: 40px;
  height: 46px;
}

.forgot-password--close-button {
  position: absolute;
  right: 2px;
  top: 2px;
  width: 24px;
  height: 24px;
  padding: 7px;
  line-height: 0;
  cursor: pointer;
}

.forgot-password--close-button img {
  width: 10px;
  height: 10px;
}

.forgot-password--button {
  margin-top: 20px;
}

.forgot-password--error {
  font-size: 12px;
  color: var(--red);
  margin: 4px 0;
}

.Tit--login {
  margin-bottom: 22px;
}

.Tit--login-sent {
  margin-top: 13px;
  margin-bottom: 20px;
}
</style>
